import { Brand } from '../components/atelier';

export interface NavProps {
  onBook: () => void;
}

export function Nav({ onBook }: NavProps) {
  return (
    <nav className="nav">
      <div className="container nav-inner">
        <Brand />
        <div className="nav-links">
          <a href="#how">How it works</a>
          <a href="#workflow">Where it fits</a>
          <a href="#output">What you get</a>
          <a href="#pricing">Pricing</a>
          <a href="#faq">FAQ</a>
        </div>
        <button type="button" className="nav-cta" onClick={onBook}>
          Book a demo
          <span style={{ fontFamily: 'var(--font-serif)', fontStyle: 'italic', color: 'var(--accent)' }}>·</span>
        </button>
      </div>
    </nav>
  );
}
